/**
* Toasts plugin declaration
* @desc This plugin provides a simple way to display toasts notifications
**/

// TODO : Seperate dependancies on _toasts.scss, _icons.scss
// It would be best to include these within the Vue files, however at the moment that could require a lot of refactoring of other code
// TODO : Add option to position Toasts container (top left/right, bottom left/right)

import Toasts from './Toasts'; // Toasts component
import module from './module'; // Vuex toasts module

export default {
  install (Vue, options) {
    if (!options.store) {
      throw new Error('Please provide vuex store.');
    }

    // Register toasts vuex module 
    options.store.registerModule('toasts', module);

    // Register toasts component
    Vue.component('toasts', Toasts);

    // Within the Vue community, it is generally expected that plugins which 
    // modify the Vue prototype prefix any added properties with a dollar sign ($).
    // this is referred to as an instance method

    // Adding $toasts to Vue.prototype allows us to use $toasts within Vue as this.$toasts()
    Vue.prototype.$toast = {
      /**
      * Add
      * @desc Adds a toast notification
      * @param {object} args - Arguments for the toast
      * @param {string} args.type - The type of toast (success, error, warning)
      * @param {number} args.duration - The length of time in ms to display the toast (defaults to 4000)
      * @param {string} args.text - The text to be displayed in the toast
      **/
      add: (args) => {
        options.store.dispatch('addToast', args);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/toasts/index.js